<template>
    <div class="esg-img-container" v-if="currentLang=='zh'">
        <div :style="'background: url(' + CompanyInfo.esgTopImg + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.environmentalImg + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.societyImg + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.companyGovernanceImg + ') center top no-repeat;height:1080px;'"></div>
    </div>
    <div class="esg-img-container" v-else>
        <div :style="'background: url(' + CompanyInfo.esgTopImgEn + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.environmentalImgEn + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.societyImgEn + ') center top no-repeat;height:1080px;'"></div>
        <div :style="'background: url(' + CompanyInfo.companyGovernanceImgEn + ') center top no-repeat;height:1080px;'"></div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import WOW from "../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      contactList:[],
      current_index:0,
      currentLang:this.$i18n.locale
    }
  },
  computed:{
    ...mapState({
      CompanyInfo:state=>state.CompanyInfo
    })
  },
  created: function () {
      this.HandleInfo();
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  
  },
  components: {
    
  },
  methods: {
     HandleInfo(){
      if (this.CompanyInfo.contactList){
        this.contactList = JSON.parse(this.CompanyInfo.contactList);
      }
     },
     ClickMap(item,index){
      this.current_index=index;
     }
  },
  watch:{
    CompanyInfo(){
      this.HandleInfo();
    }
  }
};
</script>
